/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentSettings } from './ContentSettings';
import {
    ContentSettingsFromJSON,
    ContentSettingsFromJSONTyped,
    ContentSettingsToJSON,
} from './ContentSettings';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { ProgrammeGroup } from './ProgrammeGroup';
import {
    ProgrammeGroupFromJSON,
    ProgrammeGroupFromJSONTyped,
    ProgrammeGroupToJSON,
} from './ProgrammeGroup';
import type { TermsContent } from './TermsContent';
import {
    TermsContentFromJSON,
    TermsContentFromJSONTyped,
    TermsContentToJSON,
} from './TermsContent';

/**
 * 
 * @export
 * @interface AuthProgram
 */
export interface AuthProgram {
    /**
     * 
     * @type {string}
     * @memberof AuthProgram
     */
    programmeId?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthProgram
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthProgram
     */
    location?: string;
    /**
     * 
     * @type {Product}
     * @memberof AuthProgram
     */
    product?: Product;
    /**
     * 
     * @type {string}
     * @memberof AuthProgram
     */
    businessCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthProgram
     */
    businessArea?: string;
    /**
     * 
     * @type {ContentSettings}
     * @memberof AuthProgram
     */
    contentSettings?: ContentSettings;
    /**
     * 
     * @type {Date}
     * @memberof AuthProgram
     */
    consentDate?: Date;
    /**
     * 
     * @type {TermsContent}
     * @memberof AuthProgram
     */
    termsContent?: TermsContent;
    /**
     * 
     * @type {string}
     * @memberof AuthProgram
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthProgram
     */
    acceptedTerms?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthProgram
     */
    agreementProductName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuthProgram
     */
    useNewFrontpage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AuthProgram
     */
    isOnCurrentDomain?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthProgram
     */
    ludusCode?: string;
    /**
     * 
     * @type {Array<ProgrammeGroup>}
     * @memberof AuthProgram
     */
    groups?: Array<ProgrammeGroup>;
}

/**
 * Check if a given object implements the AuthProgram interface.
 */
export function instanceOfAuthProgram(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthProgramFromJSON(json: any): AuthProgram {
    return AuthProgramFromJSONTyped(json, false);
}

export function AuthProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthProgram {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programmeId': !exists(json, 'ProgrammeId') ? undefined : json['ProgrammeId'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'location': !exists(json, 'Location') ? undefined : json['Location'],
        'product': !exists(json, 'Product') ? undefined : ProductFromJSON(json['Product']),
        'businessCountry': !exists(json, 'BusinessCountry') ? undefined : json['BusinessCountry'],
        'businessArea': !exists(json, 'BusinessArea') ? undefined : json['BusinessArea'],
        'contentSettings': !exists(json, 'ContentSettings') ? undefined : ContentSettingsFromJSON(json['ContentSettings']),
        'consentDate': !exists(json, 'ConsentDate') ? undefined : (new Date(json['ConsentDate'])),
        'termsContent': !exists(json, 'TermsContent') ? undefined : TermsContentFromJSON(json['TermsContent']),
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'acceptedTerms': !exists(json, 'AcceptedTerms') ? undefined : json['AcceptedTerms'],
        'agreementProductName': !exists(json, 'AgreementProductName') ? undefined : json['AgreementProductName'],
        'useNewFrontpage': !exists(json, 'UseNewFrontpage') ? undefined : json['UseNewFrontpage'],
        'isOnCurrentDomain': !exists(json, 'IsOnCurrentDomain') ? undefined : json['IsOnCurrentDomain'],
        'ludusCode': !exists(json, 'LudusCode') ? undefined : json['LudusCode'],
        'groups': !exists(json, 'Groups') ? undefined : ((json['Groups'] as Array<any>).map(ProgrammeGroupFromJSON)),
    };
}

export function AuthProgramToJSON(value?: AuthProgram | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProgrammeId': value.programmeId,
        'Status': value.status,
        'Location': value.location,
        'Product': ProductToJSON(value.product),
        'BusinessCountry': value.businessCountry,
        'BusinessArea': value.businessArea,
        'ContentSettings': ContentSettingsToJSON(value.contentSettings),
        'ConsentDate': value.consentDate === undefined ? undefined : (value.consentDate.toISOString()),
        'TermsContent': TermsContentToJSON(value.termsContent),
        'Name': value.name,
        'AcceptedTerms': value.acceptedTerms,
        'AgreementProductName': value.agreementProductName,
        'UseNewFrontpage': value.useNewFrontpage,
        'IsOnCurrentDomain': value.isOnCurrentDomain,
        'LudusCode': value.ludusCode,
        'Groups': value.groups === undefined ? undefined : ((value.groups as Array<any>).map(ProgrammeGroupToJSON)),
    };
}

